module.exports = __webpack_public_path__ + "slack-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/slack-logo.png
// module id = 1267
// module chunks = 74